import { DprCardComponent } from './dpr-card/dpr-card.component';
import { DprsPageComponent } from './dprs-page/dprs-page.component';

export { DprsPageComponent, DprCardComponent };

export const containerComponents = [DprsPageComponent, DprCardComponent];
